import { render, staticRenderFns } from "./save-template-bar.vue?vue&type=template&id=5fc8c07a"
import script from "./save-template-bar.vue?vue&type=script&lang=js"
export * from "./save-template-bar.vue?vue&type=script&lang=js"
import style0 from "./save-template-bar.vue?vue&type=style&index=0&id=5fc8c07a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports